import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

// v19-N2: de afdelingen van een bestaand afdelingsaccount wijzigen (oversight). Fout = editor blijft open met de keuze.
export function AfdelingenWijzig({ u, meta, onSaved }) {
  const [open, setOpen] = useState(false);
  const [keuze, setKeuze] = useState([]);
  const [bezig, setBezig] = useState(false);
  const alle = meta.afdelingenCfg || meta.afdelingen || [];
  const eigen = u.afdelingen || [];
  const opties = alle.filter((a) => a.actief !== false || eigen.includes(a.id));
  const start = () => { setKeuze([...eigen]); setOpen(true); };
  const wissel = (id) => setKeuze((k) => (k.includes(id) ? k.filter((x) => x !== id) : [...k, id]));
  const opslaan = async () => {
    setBezig(true);
    try {
      await api.patch(`/users/${u.username}/afdelingen`, { afdelingen: keuze });
      toast.success("Afdelingen bijgewerkt");
      setOpen(false);
      onSaved();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Opslaan mislukt");
    } finally { setBezig(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span data-testid={`user-afdelingen-${u.username}`} className="text-xs text-zinc-600">Afdeling: {alle.filter((a) => eigen.includes(a.id)).map((a) => a.naam).concat(eigen.filter((id) => !alle.some((a) => a.id === id))).join(", ")}</span>
      {!open && (
        <button type="button" data-testid={`user-afdelingen-wijzig-${u.username}`} onClick={start} disabled={u.active === false}
          className="min-h-[44px] md:min-h-0 px-2 md:px-1 text-xs font-semibold text-blue-700 hover:text-blue-900 disabled:opacity-50">Wijzig</button>
      )}
      {open && (
        <div data-testid={`user-afdelingen-editor-${u.username}`} className="basis-full flex flex-wrap items-center gap-x-3 gap-y-1.5 p-2 rounded-md bg-zinc-50 border border-zinc-200">
          {opties.map((a) => (
            <label key={a.id} className="flex items-center gap-1.5 text-xs text-zinc-700 select-none">
              <input type="checkbox" data-testid={`user-afdeling-${u.username}-${a.id}`} className="h-4 w-4 rounded border-zinc-300"
                checked={keuze.includes(a.id)} onChange={() => wissel(a.id)} />
              {a.naam}{a.actief === false ? " (niet actief)" : ""}
            </label>
          ))}
          <span className="flex gap-2 ml-auto">
            <button type="button" data-testid={`user-afdelingen-opslaan-${u.username}`} onClick={opslaan} disabled={!keuze.length || bezig}
              className="px-3 py-1.5 rounded-md bg-zinc-950 text-white text-xs font-semibold hover:bg-zinc-800 disabled:opacity-50">Opslaan</button>
            <button type="button" data-testid={`user-afdelingen-annuleren-${u.username}`} onClick={() => setOpen(false)}
              className="px-3 py-1.5 rounded-md border border-zinc-300 text-xs font-semibold text-zinc-700 hover:bg-zinc-100">Annuleren</button>
          </span>
        </div>
      )}
    </div>
  );
}
